import api from "./api.constant"
import layout from "./layout.constant"
import store from "./redux.constant"
import route from "./route.constant"
import translate from "./translation.constant"

export default {
  api,
  layout,
  store,
  route,
  translate,
}
